var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnectIconInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192.05 112.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .ad03fc7d-cdc4-44d4-bd6a-225e5b1902fa {\n        fill: #ff5c14;\n      }\n\n      .fe1ca6da-794f-484e-acfc-97353d0074e4 {\n        fill: url(#a211a6de-b17a-4f56-88d4-0b2214a623a9);\n      }\n\n      .a09c3e20-f1b8-47b8-90b9-a1c53a0ed42b {\n        fill: #fff;\n      }\n\n      .f510ad8f-7a6c-463c-94ed-54fa43d82c26 {\n        fill: #e5e5e5;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a211a6de-b17a-4f56-88d4-0b2214a623a9",
    x1: 94.35,
    y1: 0.02,
    x2: 96.27,
    y2: 109.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ea4d2a8d-b14c-4dba-b299-f09970c98d40",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aa82a7e4-11ca-42e6-a03d-f45f6e00d8a0",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ad03fc7d-cdc4-44d4-bd6a-225e5b1902fa",
    d: "M191.87,88.22a44,44,0,0,0-39.16-39.77,44.92,44.92,0,0,0-4.67-.24,44.11,44.11,0,0,0-8,.73c0-.25,0-.49,0-.73,0-1.2,0-2.38-.14-3.56a44.75,44.75,0,0,0-.79-5.47,44,44,0,0,0-87.1,9c0,.24,0,.49,0,.73A44,44,0,0,0,.18,88.22H0v24.25H192.05V88.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fe1ca6da-794f-484e-acfc-97353d0074e4",
    d: "M191.87,84a44,44,0,0,0-39.16-39.76A44.91,44.91,0,0,0,148,44a44.11,44.11,0,0,0-8,.73c0-.24,0-.48,0-.73,0-1.19,0-2.38-.14-3.55a44.47,44.47,0,0,0-.79-5.47A44,44,0,0,0,52,44c0,.25,0,.49,0,.73A44,44,0,0,0,.18,84H0v24.25H192.05V84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "a09c3e20-f1b8-47b8-90b9-a1c53a0ed42b",
    points: "136.04 80.26 124.04 80.26 124.04 108.27 68.02 108.27 68.02 80.26 56.02 80.26 96.03 44.68 136.04 80.26"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "f510ad8f-7a6c-463c-94ed-54fa43d82c26",
    points: "121.61 112.47 65.59 112.47 68.02 108.27 124.03 108.27 121.61 112.47"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectIconInactive);
export default __webpack_public_path__ + "static/media/connect-icon-inactive.6709bf82827cdd9c28f1fb4ecd005344.svg";
export { ForwardRef as ReactComponent };